module.exports = __webpack_public_path__ + "static/media/adwookie-conseil.9aaaa85c.png";